import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Drawer, Form, Input, InputNumber, Icon, notification, Modal, Select } from "antd";
import axios from "axios";
import { GlobalContext } from "../../../GlobalState";

const { Option } = Select
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class DrawerPagina extends Component {
    static contextType = GlobalContext
    state = {
        titulo: "",
        ordem: 1,
        tipo: 3,
        //LOADING
        iconLoading: false
    };

    UNSAFE_componentWillMount() {
        
    }

    handlerChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    handlerChangeOrdem = ordem => {
        this.setState({
            ordem
        });
    };

    handlerChangeSelect = tipo => {
        this.setState({
            tipo
        })
    }

    carregar = (paginaId) => {
        axios({
            method: "get",
            url: "/api/empresa/carregar-pagina",
            params: {
                paginaId
            }
        })
            .then(response => {
                this.setState({
                    titulo: response.data.titulo,
                    ordem: response.data.ordem,
                    tipo :response.data.tipo
                })
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar página!");

                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    }

    criar = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({
                    iconLoading: true
                });

                var item = new FormData()
                item.append("titulo", this.state.titulo);
                item.append("ordem", this.state.ordem);
                item.append("tipo", this.state.tipo);

                axios({
                    method: "post",
                    url: "/api/empresa/adicionar-pagina",
                    data: item
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", "Adicionada nova página");
                        this.setState({
                            iconLoading: false
                        }, () => this.props.atualizarRegisto());
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível adicionar página!");
                        this.setState({
                            iconLoading: false
                        });
                    });
            }
        })
    }

    alterar = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({
                    iconLoading: true
                });

                var item = new FormData()
                item.append("id", this.props.paginaId);
                item.append("titulo", this.state.titulo);
                item.append("ordem", this.state.ordem);
                item.append("tipo", this.state.tipo);

                axios({
                    method: "post",
                    url: "/api/empresa/alterar-pagina",
                    data: item
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", "Página alterada");
                        this.setState({
                            iconLoading: false
                        }, () => this.props.atualizarRegisto());
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível alterar página!");
                        this.setState({
                            iconLoading: false
                        });
                    });
            }
        })
    }

    afterVisibleChange = aberto => {
        if (aberto) {
            this.props.form.resetFields();
            if (this.props.paginaId) {
                this.carregar(this.props.paginaId);
            }
            else {
                this.setState({
                    titulo: "",
                    ordem: this.props.ordem,
                    //LOADING
                    iconLoading: false
                })
            }
        }
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            titulo,
            ordem,
            tipo,
            //LOADING
            iconLoading
        } = this.state;

        const {
            paginaId,
            visible
        } = this.props;

        return (
            <Drawer
                className="drawer-paginas"
                title={paginaId ? "Alterar" : "Adicionar"}
                width={720}
                onClose={this.props.onClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={this.afterVisibleChange}
            >
                <div className="bloco-info">
                    <Form className="form-categorias" layout="horizontal">
                        <div className="bloco">
                            <Form.Item label="Titulo">
                                {getFieldDecorator("titulo", {
                                    rules: [{ required: true, message: "Campo obrigatório" }],
                                    initialValue: titulo
                                })(<Input name="titulo" onChange={this.handlerChange} />)}
                            </Form.Item>
                            <Form.Item label="Ordem">
                                {getFieldDecorator("ordem", {
                                    rules: [{
                                        required: true,
                                        message: "Campo obrigatório"
                                    }],
                                    initialValue: ordem
                                })(<InputNumber className="input-25" name="ordem" min={1} onChange={this.handlerChangeOrdem} />)}
                            </Form.Item>
                            {this.context.id_entidade === 1 ?
                                <Form.Item label="Tipo">
                                    {getFieldDecorator("tipo", {
                                        rules: [{
                                            required: true,
                                            message: "Campo obrigatório"
                                        }],
                                        initialValue: tipo
                                    })(
                                        <Select
                                            className="input-100"
                                            placeholder="Selecionar"
                                            onChange={this.handlerChangeSelect}
                                        >
                                            <Option value={1}>Home Page</Option>
                                            <Option value={2}>Informações</Option>
                                            <Option value={3}>Catálogo</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                                : null}
                        </div>
                    </Form>
                </div>
                <div className="ant-drawer-footer">
                    <Link
                        to="#"
                        className="botao-secundario"
                        onClick={this.props.onClose}
                        style={{ marginRight: 20, display: "inline-block" }}
                    >
                        Voltar
                                </Link>
                    {paginaId ? (
                        <button className="botao-principal" disabled={iconLoading} onClick={this.alterar}>
                            {iconLoading ? <Icon type="loading" /> : null}
                            Guardar
                        </button>
                    )
                        :
                        (
                            <button className="botao-principal" disabled={iconLoading} onClick={this.criar}>
                                {iconLoading ? <Icon type="loading" /> : null}
                                Criar
                            </button>
                        )}
                </div>
            </Drawer>
        );
    }
}
const FormDrawerPagina = Form.create({ name: "form-drawer-pagina" })(DrawerPagina);

export default FormDrawerPagina;
